// Add-to-cart via BigCommerce's Storefront Cart API. The widget executes inside the
// storefront page (shadow DOM injected on directtextilestore.com), so relative URLs
// are same-origin with the shopper's real cart and their session cookie authenticates
// the write — no token, no CORS. Returns { ok:false } on any failure; the caller then
// offers the product page (a variant-level add is not reliably expressible as a GET
// permalink, so the product page is the graceful fallback).

export interface AddToCartResult {
  ok: boolean;
  error?: string;
}

const CART_API = "/api/storefront/carts";

export async function addToCart(
  productId: number,
  variantId: number,
  quantity: number,
): Promise<AddToCartResult> {
  const lineItems = [{ productId, variantId, quantity }];
  try {
    // Reuse an existing cart if the shopper already has one (GET returns an array).
    let cartId: string | undefined;
    try {
      const r = await fetch(CART_API, {
        headers: { Accept: "application/json" },
        credentials: "include",
      });
      if (r.ok) {
        const carts = await r.json();
        cartId = Array.isArray(carts) ? carts[0]?.id : carts?.id;
      }
    } catch {
      /* no existing cart / API not reachable — fall through to create */
    }

    const url = cartId ? `${CART_API}/${cartId}/items` : CART_API;
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "include",
      body: JSON.stringify({ lineItems }),
    });
    if (!res.ok) return { ok: false, error: `cart ${res.status}` };
    return { ok: true };
  } catch (err) {
    return { ok: false, error: err instanceof Error ? err.message : String(err) };
  }
}
